/*
 * Interface.
 */

/** To protect against dangling promises for re-entrant functions. */
export interface ReentrantLock {
  ensureIsUnlocked(): void;
  lock<T>(promise: Promise<T>): Promise<T>;
}

/*
 * API.
 */

export function createReentrantLock(): ReentrantLock {
  let holdCount = 0;

  return {
    ensureIsUnlocked() {
      if (holdCount > 0) {
        throw new Error('Detected dangling promise');
      }
    },
    async lock<T>(promise: Promise<T>): Promise<T> {
      holdCount++;
      try {
        return await promise;
      } finally {
        holdCount--;
      }
    },
  };
}
